<template lang="pug">
v-btn.mr-2.my-1(
    v-bind='$attrs'
    :variant='variant'
    :to='to'
    :color='color'
    :block='block'
    :icon='icon'
    tile
    size='small'
)
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'IconButton',
    props: {
        icon: {
            type: String,
            required: true,
        },
        to: {
            type: Object,
            default: undefined,
        },
        color: {
            type: String,
            default: 'primary',
        },
        block: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: 'flat',
        },
    },
});
</script>
